import Relay from 'react-relay'

class ToggleOverlayMutation extends Relay.Mutation {

    static fragments = {
        store: () => Relay.QL`
            fragment on Store {
                id,
            }
        `,
    };

    getMutation() {
        return Relay.QL`
            mutation { ToggleOverlay }
        `
    }

    getVariables() {
        return {
            id: this.props.store.id,
            overlayObjId: this.props.overlayObjId,
            isOverlayVisible: this.props.isOverlayVisible

        }
    }

    getFatQuery() {
        return Relay.QL`
            fragment on ToggleOverlayPayload{
                store
            }
        `
    }

    getConfigs() {
        return [{
            type: 'FIELDS_CHANGE',
            fieldIDs: {
                store: this.props.store.id,
            },
        }];
    }
}

export default ToggleOverlayMutation;



// WEBPACK FOOTER //
// ./app/mutations/ToggleOverlayMutation.js